import Overview from './overview.vue';
import MobFullIndex from '@rebuild/materials/shared/investment_activity/mobile/AllIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/investment_activity/context';

export function useSelfContext() {
	provideCurrentContext({
        isCustomConifg: true
	});
}

export const componentMap = {
	overview: Overview,
	'mob-full': withProvider(MobFullIndex, useSelfContext)
};
